require("../../assets/mvm-icons/icons/app-store.svg");
require('../../assets/mvm-icons/icons/burger.svg');
require('../../assets/mvm-icons/icons/camera.svg');
require('../../assets/mvm-icons/icons/check.svg');
require('../../assets/mvm-icons/icons/close.svg');
require('../../assets/mvm-icons/icons/distance.svg');
require('../../assets/mvm-icons/icons/facebook.svg');
require('../../assets/mvm-icons/icons/funds.svg');
require('../../assets/mvm-icons/icons/google-play.svg');
require('../../assets/mvm-icons/icons/instagram.svg');
require('../../assets/mvm-icons/icons/pinterest.svg');
require('../../assets/mvm-icons/icons/twitter.svg');
require('../../assets/mvm-icons/icons/lock.svg');
require('../../assets/mvm-icons/icons/left-arrow.svg');
require('../../assets/mvm-icons/icons/right-arrow.svg');
require('../../assets/mvm-icons/icons/copy.svg');
require('../../assets/mvm-icons/icons/accountability.svg');
require('../../assets/mvm-icons/icons/completed-challenge.svg');
require('../../assets/mvm-icons/icons/create.svg');
require('../../assets/mvm-icons/icons/distance-no-interline.svg');
require('../../assets/mvm-icons/icons/globe.svg');
require('../../assets/mvm-icons/icons/launch.svg');
require('../../assets/mvm-icons/icons/miles-logged.svg');
require('../../assets/mvm-icons/icons/onboard.svg');
require('../../assets/mvm-icons/icons/participants.svg');
require('../../assets/mvm-icons/icons/structure.svg');
require('../../assets/mvm-icons/icons/timeframe.svg');
require('../../assets/mvm-icons/icons/info.svg');
require('../../assets/mvm-icons/icons/marker.svg');
require('../../assets/mvm-icons/icons/watch.svg');
require('../../assets/mvm-icons/icons/milestones.svg');
require('../../assets/mvm-icons/icons/submitted-form.svg');
require('../../assets/mvm-icons/icons/app-sync.svg');
require('../../assets/mvm-icons/icons/team-building.svg');
require('../../assets/mvm-icons/icons/custom-look.svg');
require('../../assets/mvm-icons/icons/custom-routes.svg');
require('../../assets/mvm-icons/icons/engage.svg');
require('../../assets/mvm-icons/icons/route.svg');

// EXERCISE TYPES
require("../../assets/mvm-icons/exercise-types/other.svg");
require("../../assets/mvm-icons/exercise-types/steps.svg");
require("../../assets/mvm-icons/exercise-types/running_outdoor.svg");
require("../../assets/mvm-icons/exercise-types/running_indoor.svg");
require("../../assets/mvm-icons/exercise-types/walking_outdoor.svg");
require("../../assets/mvm-icons/exercise-types/walking_indoor.svg");
require("../../assets/mvm-icons/exercise-types/cycling_outdoor.svg");
require("../../assets/mvm-icons/exercise-types/cycling_indoor.svg");
require("../../assets/mvm-icons/exercise-types/swimming.svg");
require("../../assets/mvm-icons/exercise-types/rowing.svg");
require("../../assets/mvm-icons/exercise-types/elliptical.svg");
require("../../assets/mvm-icons/exercise-types/skiing.svg");
require("../../assets/mvm-icons/exercise-types/wheelchair.svg");
require("../../assets/mvm-icons/exercise-types/activities.svg");
require('../../assets/mvm-icons/exercise-types/walk_run_intervals.svg');

// LOGOS
require("../../assets/mvm-icons/logos/footer-logo.svg");
require("../../assets/mvm-icons/logos/menu-logo.svg");